const getPurposeStr = (purpose) => {
  switch (String(purpose)) {
    case "0":
      return "看房";
    case "1":
      return "入住簽約";
    case "99":
      return "其他";
    default:
      console.log(`Unknown purpose: ${purpose}`);
      return "未知";
  }
};

/**
 * Sort by startTime, then deleted state
 * the closest reservation to now is on top, and deleted in in bottom
 * @param {Reservation[]} reservations
 * @param {'ASCEND'|'DESCEND'} timeOrder sort order of startTime, ascend by default
 * @returns {Reservation[]}
 */
const sortReservation = (reservations, timeOrder = "ASCEND") => {
  let sortedReservationByTime = [];
  if (timeOrder === "DESCEND") {
    sortedReservationByTime = reservations.sort(
      (a, b) => new Date(b.startTime) - new Date(a.startTime),
    );
  } else if (timeOrder === "ASCEND") {
    sortedReservationByTime = reservations.sort(
      (a, b) => new Date(a.startTime) - new Date(b.startTime),
    );
  } else {
    console.error("Invalid timeOrder in sortReservation");
    return reservations;
  }

  return sortedReservationByTime.sort((a, b) =>
    a.deleted === b.deleted ? 0 : a.deleted ? 1 : -1,
  ); // false values first
};

const getRentingStatus = (isRenter) => {
  return isRenter ? "住戶" : "非住戶";
};

export { getPurposeStr, sortReservation, getRentingStatus };
